import React from 'react';
import { createRoot } from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Header from './common/Header';
import Footer from './common/Footer';

import Home from './home';
import WhoWeAre from './whoweare';
import WebDevelopmentPage from './WebDevelopmentPage';
import Hosting from './hosting';
import Contact from './contact';
import Success from './checkout/Success';
import Cancel from './checkout/Cancel';
import Net30ApplicationPage from './Net30ApplicationPage';
import NotFoundPage from './common/404.js';          // ← 404 page

import * as serviceWorker from './serviceWorker';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container not found');
}

const BASENAME = process.env.PUBLIC_URL || '/';

createRoot(container).render(
  <React.StrictMode>
    <BrowserRouter basename={BASENAME}>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/whoweare" element={<WhoWeAre />} />
        <Route path="/web-development" element={<WebDevelopmentPage />} />
        <Route path="/hosting" element={<Hosting />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/Net-30" element={<Net30ApplicationPage />} />
        <Route path="/checkout/success" element={<Success />} />
        <Route path="/checkout/cancel" element={<Cancel />} />
        <Route path="*" element={<NotFoundPage />} />      {/* catch-all */}
      </Routes>
      <Footer />
    </BrowserRouter>
  </React.StrictMode>
);

serviceWorker.unregister();
